import { toTypedSchema } from "@vee-validate/zod";
import { z } from "zod";

import { i18n } from "@/i18n";

const { t } = i18n.global;

const Feedback = z
  .object({
    rating: z.number({ required_error: t("validation.required") }),
    comment: z
      .string()
      .max(65000, { message: t("validation.max", { max: 65000 }) })
      .optional(),
    email: z.string().email(t("validation.email")).optional(),
    canContact: z.boolean().optional()
  })
  .refine(
    (data) => {
      if (Boolean(data.email) && !data.canContact) {
        return false;
      }

      // Both are empty, filled or canContact should be checked due to an email being there
      return true;
    },
    { path: ["canContact"] }
  )
  .refine(
    (data) => {
      if (!data.email && Boolean(data.canContact)) {
        return false;
      }

      // Both are empty, filled or email should be there due to canContact being checked
      return true;
    },
    { path: ["email"] }
  );

export type Feedback = z.infer<typeof Feedback>;

export const feedbackFormValidator = toTypedSchema(Feedback);
